export enum LocalStorageKeys {
  token = "sy_admin_token",
}
